export const formtype = {
  EntryForm: "entry",
  Report: "report",
  View: "view",
  None: "none"
};
export const prefixlist = [
  {
    Id: 1,
    Name: "Mr."
  },
  {
    Id: 2,
    Name: "Mrs."
  },
  {
    Id: 3,
    Name: "Ms."
  },
  {
    Id: 4,
    Name: "Dr."
  },
  {
    Id: 5,
    Name: "Prof."
  }
];
export const addressType = [
  {
    Id: "1",
    Name: "Present Address"
  },
  {
    Id: "2",
    Name: "Permanent Address"
  }
];



// WEBPACK FOOTER //
// ./src/utils/enums.js